import { Component, AfterViewInit, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { MatterSearchComponent } from '../../../common/matter-search/matter-search.component';

import { HttpClientService } from '../../../../services/common/http-client.service';
import { BillingService } from '../../../../services/accounting/billing.service';
import { NotyService } from '../../../../services/common/noty.service';
import { UserService } from '../../../../services/users/user.service';

@Component({
  selector: 'app-billing-index',
  templateUrl: './billing-index.component.html',
  styleUrls: ['./billing-index.component.scss']
})

export class BillingIndexComponent implements AfterViewInit, OnInit, OnDestroy {
  /**
   * Matter search component
   * @param {[type]} 'matterSearch'
  */
  @ViewChild('matterSearch') matterSearchComponent: MatterSearchComponent;

  count: number;

  billings: Array<any> = [];

  searchOptions: any = {};

  searching: boolean = false;

  sidebarMaximized: boolean = true;

  sidebarOpen: boolean = false;

  searchParams: any = {
    page: 1,
    per_page: 20,
    weekly_fees: false,
    others_billings: false,
    search: {}
  }

  total: number;

  hours: string = "";

  billable: string = "";

  private inFlightSearchKey: string | null = null;

  private lastCompletedSearchKey: string | null = null;

  /**
   * Subscription to router events to catch page changes and matter id changes in the URL
   * @type {Subscription}
   */
  routerEventsSubscription: Subscription;

  constructor(private route:             ActivatedRoute, 
              private billingService:    BillingService, 
              private httpClientService: HttpClientService,
              private notyService:       NotyService,
              private router:            Router,
              private userService:       UserService) {                
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.initialize();
    });
  }

  ngOnInit(): void {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
    this.initialize();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 5000);
  }

  /**
   * Called when component is destroyed
   */
  ngOnDestroy() {
    this.routerEventsSubscription.unsubscribe();
  }

  @HostListener('window:scroll', ['$event'])
  window_scroll() {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
  window_resize() {
    this.content_sidebar_scroll();
  }

  clearSearch = () => {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });  
    this.resetSearchParams();
    this.search();
  }

  initialize() {    
    this.resetSearchParams();
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    this.billingService.index({search_options:true}).then(response_json=>{
      this.searchOptions = response_json;
      if(this.searchOptions && this.searchOptions.per_page)
        this.searchParams.per_page = this.searchOptions.per_page;
      this.search(null, true);
    });
  }

  resetSearchParams() {
    this.searchParams = {
      page: 1,
      per_page: 20,
      weekly_fees: false,
      others_billings: false,
      search: {}
    }
  }

  search(pageEvent: any = null, isSearching: boolean | null = false): Promise<any> {
    if (pageEvent) this.searchParams.page = pageEvent.page;
    let searchKey: string = this.searchKey();
    if (pageEvent && (this.inFlightSearchKey === searchKey || this.lastCompletedSearchKey === searchKey))
      return Promise.resolve(null);
    if (isSearching)
      this.searching = true;
    this.inFlightSearchKey = searchKey;
    return this.billingService.index(this.searchParams).then(response_json => {
      this.billings = response_json.billings;
      this.count = response_json.count;
      this.total = response_json.total;
      this.hours = response_json.hours;
      this.billable = response_json.billable;
      this.lastCompletedSearchKey = searchKey;
      if (this.inFlightSearchKey === searchKey)
        this.inFlightSearchKey = null;
      if (isSearching)
        this.searching = false;
      let newPageUrl: string = this.httpClientService.buildNewPageUrl(`/${this.billingService.url}`, this.searchParams);
      if(!this.currentUrlMatches(newPageUrl))
        this.httpClientService.setNewPageUrl(newPageUrl);
    }).catch(() => {
      if (this.inFlightSearchKey === searchKey)
        this.inFlightSearchKey = null;
      this.searching = false;
      this.notyService.notify('Error loading billings', 'error');
    })
  }

  currentUrlMatches(url: string): boolean {
    let targetUrl = new URL(url, window.location.href);
    return `${window.location.pathname}${window.location.search}` === `${targetUrl.pathname}${targetUrl.search}`;
  }

  private searchKey(): string {
    return this.httpClientService.buildNewPageUrl(`/${this.billingService.url}`, this.searchParams);
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}
